var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.94 26.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84,13.11V13c1.3-.11,4.52-2,5.94-2.69,3.75-1.89,7.06.85,9.25.85,1.3,0,4-1.22,5.91-1.28a3.79,3.79,0,0,1,2.13.19c1.32.44,2.23,1,3.44,1.45a13.52,13.52,0,0,0,3.63,1.24c-.46.63-3.77,2-4.81,2.39a32.55,32.55,0,0,1-7.91,1.69c-5.05.25-7.88.08-12.58-1.49a32.12,32.12,0,0,1-4.2-1.79,2.73,2.73,0,0,0-.8-.4Zm35.09-1.28v0c0,.36-.27.43-.49.69L39.08,14.3c-.81,1.08-4.24,5.58-5.16,6.51l-1.54,1.66a14.93,14.93,0,0,1-3.52,2.8,5,5,0,0,1-1.65.5c-4.78.77-9.41,1.13-14-.78-5.35-2.23-9-9.36-12.09-11.66-.33-.25-1-.56-1.14-.91v-.17c0-.12.17-.25.43-.39A10.16,10.16,0,0,0,2.53,10c.27-.35.5-.52.75-.84a5.08,5.08,0,0,1,.38-.43l1.09-1.3C4.9,7.2,5,7.15,5.14,7s.18-.25.36-.44C6.27,5.73,6.82,5,7.78,4c1.46-1.47,3.6-3.7,5.89-3.7a9,9,0,0,1,4,1.15,17.29,17.29,0,0,1,2.82,2.21,8.47,8.47,0,0,1,2.9-2.53A8.36,8.36,0,0,1,28.07,0c1.77,0,4,1.69,5,2.82L37.91,8.7a18.93,18.93,0,0,0,2.21,2.43c.24.19.81.38.82.7Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE8);
export default __webpack_public_path__ + "static/media/E8.cd8c2cce8fb9e07d6e526f6a3c5438fc.svg";
export { ForwardRef as ReactComponent };